/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import Component from '@glimmer/component';
import { CampaignType, ObjectRelationshipTriggerType, ObjectTriggerType } from 'cio/models/campaign';
import { TriggerCardItem } from 'cio/components/campaigns/trigger/type-selector';

interface CampaignTriggerTypeSelectorCardArgs {
  type: TriggerCardItem;
  selectedType: CampaignType;
  onChangeType: (
    type: CampaignType,
    label: string,
    objectTypeId?: string,
    subType?: ObjectTriggerType | ObjectRelationshipTriggerType,
  ) => void;
  triggerIsSaved: boolean;
}

export default class CampaignTriggerTypeSelectorCard extends Component<CampaignTriggerTypeSelectorCardArgs> {
  readonly subTypeChangedValue = ObjectTriggerType.Updated;

  get typeId() {
    let { type } = this.args;
    if (type.subType != null) {
      return `${type.id}_${type.objectTypeId}_${type.subType}`;
    }
    return type.id;
  }
}
